import * as z from 'zod';

import { booleanMutationSchema } from '@/_schemas/generic';

import { invoiceBatchFormSchema } from './invoice-batches-form-schema';

import { invoiceCreateSchema } from '../invoices/invoice-mutation-schema';

export const invoiceBatchMutationSchema = invoiceBatchFormSchema
  .omit({ invoices: true, is_generating_pdfs: true, invoice_batch_started: true, payment_method: true })
  .extend({
    is_paid: booleanMutationSchema(),
    inherit_agreement_creation_date: booleanMutationSchema(),
    payment_method_id: z.number().nullable(),
    printable_invoices_pdf: z.array(z.number()),
    digital_invoices_pdf: z.array(z.number()),
  });

export type InvoiceBatchMutationSchema = z.infer<typeof invoiceBatchMutationSchema>;

export const invoiceBatchCreationWithInvoicesSchema = invoiceBatchMutationSchema
  .omit({
    id: true,
    created_at: true,
    printable_invoices_pdf: true,
    digital_invoices_pdf: true,
  })
  .extend({
    invoices: z.array(invoiceCreateSchema),
    start_date: z.string(),
    end_date: z.string(),
  });

export type InvoiceBatchCreationWithInvoicesSchema = z.infer<typeof invoiceBatchCreationWithInvoicesSchema>;
